import React, { useEffect, useState, useRef } from 'react';
import '../../App.css';
import services from '../../services';
import moment from 'moment';
import MyDayPlanDropdown from '../Task/MyDayPlanDropdown';
import TaskDeadline from '../Task/TaskDeadline';
import AssignDropdown from '../Task/AssignDropdown';
import { useDispatch } from 'react-redux';
import { getAllBoardDateTable, getAllDateTableTask } from '../../Redux/GetSlice';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import axios from 'axios';
import TaskDropdownModal from '../TaskDropdownModal';
import ConfirmationPopup from '../ConfirmationPopup';
import { useNavigate } from 'react-router-dom';
import { addTaskToDateTable } from '../../Redux/slice';

function DatePlan(props) {
    const {
        selectedBoardId,
        getTaskMail,
        toggleTaskDropdown,
        isDateModal,
        showBox,
        setShowBox,
        setHoverIndex,
        setColorIndexID,
        activePatch,
        handleClick,
        removeTask,
        deleteTaskMail,
        taskToDelete,
        setTaskToDelete,
        handleCancelDelete,
    } = props;
    const { dateTableData, selecteAssignUser } = useSelector((state) => state?.redux);
    const [tasks, setTasks] = useState(dateTableData?.data);
    const [editingTaskId, setEditingTaskId] = useState(null);
    const [editTaskTitle, setEditTaskTitle] = useState('');

    const getUserData = () => {
        try {
            const raw = localStorage.getItem("userData");
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
        } catch (e) {
            console.error("Invalid userData in localStorage", e);
            return null;
        }
    };

    const userData = getUserData();

    useEffect(() => {
        if (dateTableData?.data) {
            setTasks(dateTableData.data);
        }
    }, [dateTableData]);

    const handleTaskSelectedColorLocal = (taskId, color) => {
        const taskToUpdate = tasks.find((t) => t.id === taskId);
        if (taskToUpdate) {
            handleUpdateTask(color, 'color', taskToUpdate);
        }
    };

    const clearHighlightLocal = (task) => {
        handleUpdateTask(null, 'color', task);
    };

    const [taskMyDayDates, setTaskMyDayDates] = useState({});
    const [taskDeadlineDates, setTaskDeadlineDates] = useState({});
    const navigate = useNavigate();

    const getTaskMyDayDate = (taskId) => {
        return taskMyDayDates[taskId] || null;
    };

    const getTaskDeadlineDate = (taskId) => {
        return taskDeadlineDates[taskId] || null;
    };

    const setTaskMyDayDate = (taskId, date) => {
        setTaskMyDayDates((prev) => ({
            ...prev,
            [taskId]: date,
        }));
    };

    const setTaskDeadlineDate = (taskId, date) => {
        setTaskDeadlineDates((prev) => ({
            ...prev,
            [taskId]: date,
        }));
    };

    const getMonthDates = () => {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();
        const startDay = today.getDate();
        const monthDates = [];
        const daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        for (let i = startDay; i <= daysInCurrentMonth; i++) {
            monthDates.push(new Date(currentYear, currentMonth, i));
        }
        const nextMonth = currentMonth + 1;
        const nextMonthYear = nextMonth > 11 ? currentYear + 1 : currentYear;
        const nextMonthAdjusted = nextMonth > 11 ? 0 : nextMonth;
        const daysInNextMonth = new Date(nextMonthYear, nextMonthAdjusted + 1, 0).getDate();
        for (let day = 1; day <= daysInNextMonth; day++) {
            monthDates.push(new Date(nextMonthYear, nextMonthAdjusted, day));
        }

        return monthDates;
    };

    const formatDate = (date) => {
        const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        return {
            day: days[date.getDay()],
            month: months[date.getMonth()],
            date: date.getDate(),
        };
    };

    const today = new Date();
    const monthDates = getMonthDates();

    const columns = monthDates.map((date, index) => {
        const formattedDate = formatDate(date);
        const isToday = date.toDateString() === today.toDateString();
        const title = isToday
            ? `TODAY, ${formattedDate.month} ${formattedDate.date}`
            : `${formattedDate.day}, ${formattedDate.month} ${formattedDate.date}`;

        return {
            id: `col${index + 1}`,
            title: title,
            type: isToday ? 'today' : 'future',
            date: date,
        };
    });
    const [hoveredTaskId, setHoveredTaskId] = useState(null);
    const [openDropdownTaskId, setOpenDropdownTaskId] = useState(null);
    const [openDropdownType, setOpenDropdownType] = useState(null);
    const [openAssignDropdownTaskId, setOpenAssignDropdownTaskId] = useState(null);
    const [openMyDayPlanDropdown, setOpenMyDayPlanDropdown] = useState(null);
    const [openTaskDeadlineDropdown, setOpenTaskDeadlineDropdown] = useState(null);
    const [userList, setUserList] = useState([]);
    const [activeDateType, setActiveDateType] = useState({});
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const [assignDropdownPosition, setAssignDropdownPosition] = useState(null);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const initializedRef = useRef(false);
    const dropdownRef = useRef(null);

    const getTasksForColumn = (columnDate) => {
        if (!tasks || tasks.length === 0) return [];

        return tasks.filter((task) => {
            if (!task.myDayPlan) {
                return false;
            }

            if (typeof task.myDayPlan === 'string' && task.myDayPlan.match(/^[A-Za-z]{3}\s+\d{1,2}:\d{2}\s+[AP]M$/)) {
                const dayFromPlan = task.myDayPlan.substring(0, 3).toUpperCase();
                const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
                const columnDay = days[columnDate.getDay()];
                const isMatch = dayFromPlan === columnDay;
                return isMatch;
            }

            let taskDate;
            try {
                if (typeof task.myDayPlan === 'string') {

                    if (task.myDayPlan.match(/^[A-Za-z]{3}\s+\d{1,2}$/)) {
                        const currentYear = new Date().getFullYear();
                        taskDate = moment(`${task.myDayPlan} ${currentYear}`, 'MMM DD YYYY').toDate();
                    } else {
                        taskDate = moment(task.myDayPlan).toDate();
                    }
                } else {
                    taskDate = new Date(task.myDayPlan);
                }
            } catch (error) {
                console.error('Error parsing task myDayPlan:', task.myDayPlan, error);
                return false;
            }

            const taskDateOnly = new Date(taskDate.getFullYear(), taskDate.getMonth(), taskDate.getDate());
            const columnDateOnly = new Date(columnDate.getFullYear(), columnDate.getMonth(), columnDate.getDate());

            const isMatch = taskDateOnly.getTime() === columnDateOnly.getTime();

            return isMatch;
        });
    };
    const handleAddTask = async (columnId) => {
        const columnIndex = parseInt(columnId.replace('col', '')) - 1;
        const columnDate = columns[columnIndex].date;

        const selectedBoard = boardList.find((b) => b.id === selectedBoardId);
        if (!selectedBoard || !selectedBoard.BoardLists || !selectedBoard.BoardLists.length === 0) {
            return;
        }

        const defaultColumn =
            selectedBoard.BoardLists.find((list) => list.sequence === 1) || selectedBoard.BoardLists[0];
        if (!defaultColumn) {
            return;
        }

        const newTaskPayload = {
            boardListId: defaultColumn.id,
            title: 'type your task name here',
            myDayPlan: moment(columnDate).format(),
            boardId: selectedBoardId,
            ...(userData?.role === "User" ? { userId: userData?.id } : {}),
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, newTaskPayload);
            if (response.status === 201 && response.data?.data) {
                const serverTask = response.data.data;
                const newTaskForUI = {
                    ...serverTask,
                    type: 'task',
                    name: serverTask.title,
                };
                dispatch(getAllDateTableTask({ data: newTaskForUI }));
            }
        } catch (error) {
            console.error('Error creating task:', error);
        }
    };

    const dispatch = useDispatch();

    const handleAssignChange = (e, taskId) => {
        if (openAssignDropdownTaskId === taskId) {
            setOpenAssignDropdownTaskId(null);
            setHoveredTaskId(null);
        } else {
            const rect = e.currentTarget.getBoundingClientRect();
            setAssignDropdownPosition({ top: rect.bottom + 2, right: window.innerWidth - rect.right });
            setOpenAssignDropdownTaskId(taskId);
            setOpenMyDayPlanDropdown(null);
            setOpenTaskDeadlineDropdown(null);
        }
    };

    const handleAssign = (event) => { };

    const handleInputChange = (event) => { };

    const handleClearAssignment = () => {
        setOpenAssignDropdownTaskId(null);
        setHoveredTaskId(null);
    };

    const clearDateSelection = (taskId) => {
        setTaskMyDayDate(taskId, null);
        setTaskDeadlineDate(taskId, null);
        setActiveDateType((prev) => ({ ...prev, [taskId]: null }));
    };

    const handleClockIconClick = (taskId) => {
        if (openDropdownType === taskId) {
            setOpenDropdownType(null);
        } else {
            setOpenDropdownType(taskId);
        }
    };

    const handleMyDayPlanClick = (taskId) => {
        if (openMyDayPlanDropdown === taskId) {
            setOpenMyDayPlanDropdown(null);

            setHoveredTaskId(null);
        } else {
            setOpenMyDayPlanDropdown(taskId);
            setOpenAssignDropdownTaskId(null);
            setOpenTaskDeadlineDropdown(null);
        }
    };

    const handleTaskDeadlineClick = (taskId) => {
        if (openTaskDeadlineDropdown === taskId) {
            setOpenTaskDeadlineDropdown(null);

            setHoveredTaskId(null);
        } else {
            setOpenTaskDeadlineDropdown(taskId);
            setOpenAssignDropdownTaskId(null);
            setOpenMyDayPlanDropdown(null);
        }
    };

    const handleUpdateTask = async (value, type, taskItem) => {
        if (!taskItem?.id) {
            console.error('DatePlan - No task ID provided');
            return;
        }
        try {
            const data = {};

            const currentTask = tasks.find((t) => t.id === taskItem.id);
            const currentMyDayPlan = getTaskMyDayDate(taskItem.id) || currentTask?.myDayPlan;
            const currentDeadline = getTaskDeadlineDate(taskItem.id) || currentTask?.deadline;

            switch (type) {
                case 'myDay':
                    data.myDayPlan = value;
                    data.deadline = currentDeadline;
                    setTaskMyDayDate(taskItem.id, value);
                    break;
                case 'deadline':
                    data.deadline = value;
                    data.myDayPlan = currentMyDayPlan;
                    setTaskDeadlineDate(taskItem.id, value);
                    break;
                case 'title':
                    data.title = value;
                    break;
                case 'color':
                    data.color = value;
                    break;
                case 'status':
                    data.status = value;
                    break;
                default:
                    console.warn('DatePlan - Unknown type:', type);
                    break;
            }

            if (Object.keys(data).length > 0) {
                const response = await axios.put(
                    `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${taskItem.id}`,
                    data,
                );

                if (response.status === 200) {
                    setTasks((prevTasks) =>
                        prevTasks.map((task) => (task.id === taskItem.id ? { ...task, ...response.data.data } : task)),
                    );

                    return response.data;
                }
            }
        } catch (error) {
            console.error('DatePlan - Error updating task:', error);
            throw error;
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownTaskId(null);
                setOpenDropdownType(null);
                setOpenAssignDropdownTaskId(null);
                setOpenMyDayPlanDropdown(null);
                setOpenTaskDeadlineDropdown(null);
                setHoveredTaskId(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.assign-dropdown-wrapper')) {
                setOpenAssignDropdownTaskId(null);
                setHoveredTaskId(null);
            }
        };

        if (openAssignDropdownTaskId) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openAssignDropdownTaskId]);

    const [openBoardTaskId, setOpenBoardTaskId] = useState(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.board-dropdown-wrapper')) {
                setOpenBoardTaskId(null);
            }
        };

        if (openBoardTaskId) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openBoardTaskId]);

    const [boardList, setBoardList] = useState([]);
    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            setBoardList(response?.data?.data);
        } catch (error) {
            console.error('Error fetching board date table:', error);
        }
    };

    const handleBoardColumnSelect = async (taskId, coloum, boardData, selectedBoardId) => {
        const updatedTasks = tasks.map((t) => (t.id === taskId ? { ...t, BoardList: { ...t.BoardList, coloum } } : t));
        setTasks(updatedTasks);
        setOpenBoardTaskId(null);

        try {
            const data = {
                boardId: boardData?.boardId,
                boardListId: boardData?.id,
            };

            await services.task.UPDATE_TASK_GMAIL_WHATSAAP(taskId, data);

            getTaskMail();
        } catch (error) {
            console.error('Error updating task:', error);
        }
    };

    const getAllTask = async () => {
        const data = {
            boardId: selectedBoardId,
        };
        await dispatch(getAllDateTableTask({ data }));
    };

    useEffect(() => {
        getAllTask();
    }, [selectedBoardId]);

    useEffect(() => {
        getAllBoardDateTable();
    }, []);

    useEffect(() => {
        setTasks(dateTableData?.data);
        if (dateTableData?.data && !initializedRef.current) {
            const initialMyDayDates = {};
            const initialDeadlineDates = {};

            dateTableData.data.forEach((task) => {
                if (task.myDayPlan) {
                    initialMyDayDates[task.id] = task.myDayPlan;
                }
                if (task.deadline) {
                    initialDeadlineDates[task.id] = task.deadline;
                }
            });

            setTaskMyDayDates(initialMyDayDates);
            setTaskDeadlineDates(initialDeadlineDates);
            initializedRef.current = true;
        }
    }, [dateTableData]);

    const handleTaskNameChange = (taskId, newName) => {
        setTasks((tasks) => tasks.map((task) => (task.id === taskId ? { ...task, name: newName } : task)));
    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';

        const inputDate = new Date(date);
        if (inputDate.getHours() === 0 && inputDate.getMinutes() === 0) {
            return '';
        }
        const timeString = inputDate.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });

        return timeString;
    };

    const handleEmailDrop = async (draggedItem, droppedDate) => {
        try {
            const gmailMessageId =
                draggedItem?.gmailMessage ||
                draggedItem?.gmailMessageId ||
                draggedItem?.gmailMessageId ||
                draggedItem?.id;

            if (!gmailMessageId) {
                console.warn('No Gmail Message ID found in dragged item:', draggedItem);
                return;
            }

            if (!boardList || boardList.length === 0) {
                await getAllBoardDateTable();
            }

            const selectedBoard = boardList.find((b) => b.id === selectedBoardId);

            if (!selectedBoard || !selectedBoard.BoardLists || selectedBoard.BoardLists.length === 0) {
                console.error('No board or board lists found for selectedBoardId:', selectedBoardId);
                return;
            }

            const defaultColumn = selectedBoard?.BoardLists?.find((item) => item?.sequence === 1);

            const formattedDate = moment(droppedDate).format('MMM DD');

            const payload = {
                boardListId: defaultColumn?.id,
                title: '',
                taskType: 'Gmail',
                gmailMessageId: gmailMessageId,
                myDayPlan: formattedDate,
                boardId: selectedBoardId,
                ...(userData?.role === "User" ? { userId: userData?.id } : {}),
            };
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/task/createTask`, payload);

            if (response.status === 200) {

                const newTask = {
                    id: response.data?.data?.id || `temp-${Date.now()}`,
                    taskType: 'Gmail',
                    gmailMessageId: gmailMessageId,
                    myDayPlan: formattedDate,
                    subject: draggedItem?.subject || 'Email Task',
                    BoardList: { coloum: defaultColumn?.coloum },
                    ...response.data?.data,
                };

                setTasks((prevTasks) => [...(prevTasks || []), newTask]);
                setTaskMyDayDate(newTask.id, formattedDate);
            }

            getAllTask();
        } catch (error) {
            console.error(' Task creation failed:', error);
        }
    };

    useEffect(() => {
        if (selectedTask) {
            toggleTaskDropdown(selectedTask.id, selectedTask);
        }
    }, [selectedTask]);

    const handleTaskDropdownToggle = (id, task) => {
        if (selectedTask?.id === id) {
            setSelectedTask(null);
            toggleTaskDropdown(false);
            setOpenAssignDropdownTaskId(null);
            setOpenMyDayPlanDropdown(null);
            setOpenTaskDeadlineDropdown(null);
        } else {
            setSelectedTask(task);
            toggleTaskDropdown(true);
            setOpenAssignDropdownTaskId(null);
            setOpenMyDayPlanDropdown(null);
            setOpenTaskDeadlineDropdown(null);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectedTask && !event.target.closest('.dropdown-tactic')) {
                setSelectedTask(null);
                toggleTaskDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectedTask, toggleTaskDropdown]);

    const [selectedAssighUser, setSelectedAssighUser] = useState({});
    const handleSetSelectedAssighUser = (taskId, userId) => {
        setSelectedAssighUser((prev) => ({
            ...prev,
            [taskId]: userId,
        }));
    };

    // getAllUserList effect removed, now using userList prop from AppViewer

    return (
        <div
            ref={dropdownRef}
            style={{ display: 'flex', height: '100vh', borderTop: '1px solid #ccc' }}
        >
            {columns.map((column) => {
                const columnTasks = getTasksForColumn(column.date);

                return (
                    <Droppable droppableId={`date-view-${column.date.toISOString()}`} key={column.id}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                    minWidth: '300px',
                                    flex: '1',
                                    borderRight: '1px solid #ccc',
                                    padding: '10px 18px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    boxSizing: 'border-box',
                                    backgroundColor: snapshot.isDraggingOver ? '#f9f9f9' : 'transparent',
                                }}
                            >
                                <div className="flex justify-center items-center">
                                    <h2
                                        style={{
                                            fontSize: '15px',
                                            fontWeight: '500',
                                            marginBottom: '15px',

                                            borderBottom: '4px solid #42b4f4',
                                            borderImage: 'linear-gradient(to right, #42b4f4, #42b4f4)) 1',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            fontFamily: 'Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif',
                                        }}
                                    >
                                        {column.title}

                                    </h2>

                                    <span></span>
                                </div>

                                <div style={{ overflowY: 'auto', flexGrow: '1', scrollbarWidth: 'none' }}>
                                    {columnTasks.map((task, idx) => {
                                        const assignedUserId = selectedAssighUser[task.id] || task.userId;
                                        const assignedUser = userList && userList.find((user) => user.id === assignedUserId);
                                        return (
                                            <div key={task.id}>
                                                {task.type === 'task' ? (
                                                    <div
                                                        className={`task-card`}
                                                        onClick={(e) => {
                                                            const interactiveElements = [
                                                                'button',
                                                                'a',
                                                                'input',
                                                                'textarea',
                                                                '[role="button"]',
                                                            ];
                                                            if (
                                                                interactiveElements.some((selector) =>
                                                                    e.target.closest(selector),
                                                                )
                                                            ) {
                                                                return;
                                                            }
                                                            navigate(`/detail/${task.id}`, {
                                                                state: {
                                                                    selectedMail: task,
                                                                    deadlineDate: taskDeadlineDates,
                                                                    taskID: task.id,
                                                                    clickMailTask: true,
                                                                    type: 'task',
                                                                    openTaskDataSidebar: true,
                                                                    currentTask: task,
                                                                    boardId: selectedBoardId
                                                                    // boardName: boardName
                                                                },
                                                            });
                                                        }}
                                                        style={{
                                                            background: task?.color || '#f2f6fc',
                                                            padding: 10,
                                                            borderRadius: 6,
                                                            marginBottom: 8,
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'start',
                                                            }}
                                                        >
                                                            <textarea
                                                                placeholder="type your task name here"
                                                                value={task.name || ''}
                                                                onChange={(e) => handleTaskNameChange(task.id, e.target.value)}
                                                                onKeyDown={async (e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        await handleUpdateTask(e.target.value, 'title', task);
                                                                    }
                                                                }}
                                                                onBlur={async (e) => {
                                                                    await handleUpdateTask(e.target.value, 'title', task);
                                                                }}
                                                                className="input-static1 outline-text !h-auto overflow-hidden resize-none focus:border-none !focus:outline-none placeholder:text-[#000]"
                                                                rows={1}

                                                            />
                                                            <span style={{ fontSize: 'small', color: '#555', marginLeft: 8 }}>
                                                                {formatDateForDisplay(task.myDayPlan)}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div className="deadline-align flex gap-2">
                                                                <div className="calendar-dropdown master-calendar flex">

                                                                </div>
                                                                <div className="calendar-dropdown master-calendar flex">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {task.taskType === 'Gmail' && (
                                                            <div
                                                                // onClick={(e) => {
                                                                //     const interactiveElements = [
                                                                //         'button',
                                                                //         'a',
                                                                //         'input',
                                                                //         'textarea',
                                                                //         '[role="button"]',
                                                                //         '[data-no-popup]',
                                                                //     ];
                                                                //     if (
                                                                //         interactiveElements.some((selector) =>
                                                                //             e.target.closest(selector),
                                                                //         )
                                                                //     ) {
                                                                //         return;
                                                                //     }
                                                                //     navigate(`/detail/${task.id}`, {
                                                                //         state: {
                                                                //             selectedMail: task,
                                                                //             deadlineDate: taskDeadlineDates,
                                                                //             taskID: task.id,
                                                                //             clickMailTask: true,
                                                                //             type: 'Gmail',
                                                                //             openTaskDataSidebar: true,
                                                                //             currentTask: task,
                                                                //             boardId: selectedBoardId
                                                                //             // boardName: boardName
                                                                //         },
                                                                //     });
                                                                // }}
                                                                onMouseEnter={() => setHoveredTaskId(task.id)}
                                                                onMouseLeave={() => {

                                                                    if (
                                                                        openAssignDropdownTaskId !== task.id &&
                                                                        openMyDayPlanDropdown !== task.id &&
                                                                        openTaskDeadlineDropdown !== task.id
                                                                    ) {
                                                                        setHoveredTaskId(null);
                                                                    }
                                                                }}
                                                                style={{
                                                                    background: task?.color || '#f6f9fd',

                                                                    borderRadius: '8px',
                                                                    padding: '12px 12px',
                                                                    marginBottom: '10px',
                                                                    border: '1px solid #e3e8ee',
                                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                                                    fontSize: '14px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: '8px',
                                                                    position: 'relative',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <div
                                                                    style={{ display: 'flex', alignItems: 'start', gap: '8px' }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            color: '#222',
                                                                            fontWeight: 500,
                                                                            textAlign: 'start',
                                                                            wordBreak: 'break-word',
                                                                            whiteSpace: 'pre-line',
                                                                            overflowWrap: 'break-word',
                                                                            maxWidth: '100%',
                                                                            flexGrow: 1,
                                                                        }}
                                                                    >
                                                                        {editingTaskId === task.id ? (
                                                                            <textarea
                                                                                value={editTaskTitle}
                                                                                onChange={(e) =>
                                                                                    setEditTaskTitle(e.target.value)
                                                                                }
                                                                                onKeyDown={async (e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        e.preventDefault();
                                                                                        await handleUpdateTask(
                                                                                            editTaskTitle,
                                                                                            'title',
                                                                                            task,
                                                                                        );
                                                                                        setEditingTaskId(null);
                                                                                    }
                                                                                }}
                                                                                onBlur={async () => {
                                                                                    await handleUpdateTask(
                                                                                        editTaskTitle,
                                                                                        'title',
                                                                                        task,
                                                                                    );
                                                                                    setEditingTaskId(null);
                                                                                }}
                                                                                autoFocus
                                                                                className="input-static1 outline-text !h-auto overflow-hidden resize-none focus:border-none !focus:outline-none placeholder:text-[#000]"
                                                                                style={{ background: 'transparent' }}
                                                                            />
                                                                        ) : (
                                                                            (() => {
                                                                                const titleToShow = task.title || task.subject;
                                                                                return titleToShow && titleToShow.length > 50
                                                                                    ? `${titleToShow.slice(0, 50)}...`
                                                                                    : titleToShow;
                                                                            })()
                                                                        )}
                                                                    </div>
                                                                    <div className="flex items-center gap-2">
                                                                        <span
                                                                            style={{
                                                                                color: '#888',
                                                                                fontSize: '13px',
                                                                                whiteSpace: 'nowrap',
                                                                            }}
                                                                        >
                                                                            {task?.createdAt
                                                                                ? moment(task.createdAt).format('MMM DD')
                                                                                : 'No Date'}
                                                                        </span>

                                                                        <button
                                                                            className={`arrow functionality-open ${isDateModal ? 'open' : ''
                                                                                }`}
                                                                            style={{
                                                                                visibility:
                                                                                    hoveredTaskId === task.id
                                                                                        ? 'visible'
                                                                                        : 'hidden',
                                                                            }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                const rect =
                                                                                    e.currentTarget.getBoundingClientRect();
                                                                                setDropdownPosition({
                                                                                    top: rect.bottom,
                                                                                    left: rect.left - 130,
                                                                                });
                                                                                toggleTaskDropdown(task?.id, task);
                                                                                handleTaskDropdownToggle(task?.id, task);
                                                                                setTaskToDelete(task?.id);
                                                                            }}
                                                                            data-no-popup
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="10"
                                                                                height="10"
                                                                                fill="currentColor"
                                                                                className="bi bi-chevron-down down-bottom"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                                                                />
                                                                            </svg>
                                                                        </button>
                                                                    </div>

                                                                    {selectedTask?.id === task?.id && (
                                                                        <TaskDropdownModal
                                                                            isOpen={isDateModal}
                                                                            onClose={() =>
                                                                                handleTaskDropdownToggle(
                                                                                    selectedTask?.id,
                                                                                    selectedTask,
                                                                                )
                                                                            }
                                                                            item={selectedTask}
                                                                            handleEditTitle={() => {
                                                                                setEditingTaskId(task.id);
                                                                                setEditTaskTitle(task.title || task.subject);
                                                                                toggleTaskDropdown(false);
                                                                            }}
                                                                            setShowBox={setShowBox}
                                                                            removeTask={removeTask}
                                                                            clearHighlight={() => clearHighlightLocal(task)}
                                                                            handleClick={handleClick}
                                                                            setHoverIndex={setHoverIndex}
                                                                            setColorIndexID={setColorIndexID}
                                                                            handleTaskSelectedColor={
                                                                                handleTaskSelectedColorLocal
                                                                            }
                                                                            activePatch={activePatch}
                                                                            indexId={idx}
                                                                            selectedBoardId={selectedBoardId}
                                                                            taskDeadlineDates={taskDeadlineDates}
                                                                            handleUpdateTask={handleUpdateTask}
                                                                            position={dropdownPosition}
                                                                        />
                                                                    )}
                                                                </div>

                                                                {task?.BoardList?.coloum && (
                                                                    <span
                                                                        style={{
                                                                            background: '#7bc47f',
                                                                            color: '#fff',
                                                                            borderRadius: '4px',
                                                                            fontSize: '12px',
                                                                            padding: '2px 8px',
                                                                            display: 'inline-block',
                                                                            width: 'fit-content',
                                                                        }}
                                                                        onClick={async (e) => {
                                                                            e.stopPropagation();
                                                                            if (openBoardTaskId === task.id) {
                                                                                setOpenBoardTaskId(null);
                                                                            } else {
                                                                                setOpenBoardTaskId(task.id);
                                                                                await getAllBoardDateTable();
                                                                            }
                                                                        }}
                                                                    >
                                                                        {task?.BoardList?.coloum}
                                                                    </span>
                                                                )}
                                                                <div className="board-dropdown-wrapper">
                                                                    {openBoardTaskId === task.id && (
                                                                        <div className="absolute right-0 mt-2 w-[240px] bg-white border rounded-lg shadow-xl z-30">
                                                                            <div className="relative border-b">
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Search"
                                                                                    className="w-full px-10 py-2 text-sm focus:outline-none"


                                                                                />
                                                                                <div className="absolute left-3 top-2.5 text-gray-400 text-sm">
                                                                                    🔍
                                                                                </div>
                                                                            </div>

                                                                            <div className="max-h-64 overflow-y-auto text-sm">
                                                                                {boardList && boardList.length > 0 ? (
                                                                                    boardList.map((board, boardIdx) => (
                                                                                        <React.Fragment
                                                                                            key={board.boardName + boardIdx}
                                                                                        >
                                                                                            <div className="uppercase text-[11px] text-black font-bold px-4 pt-3 pb-1 border-t first:border-none text-left">
                                                                                                {board.boardName}
                                                                                            </div>

                                                                                            <ul
                                                                                                className="list-none"
                                                                                                style={{ padding: 0 }}
                                                                                            >
                                                                                                {board.BoardLists &&
                                                                                                    board.BoardLists.length > 0 ? (
                                                                                                    board.BoardLists.map(
                                                                                                        (col, colIdx) => (
                                                                                                            <li
                                                                                                                key={
                                                                                                                    col.coloum +
                                                                                                                    colIdx
                                                                                                                }
                                                                                                                className="px-4 py-2 hover:bg-gray-100 text-gray-800 cursor-pointer text-sm text-left"
                                                                                                                onClick={(
                                                                                                                    e,
                                                                                                                ) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleBoardColumnSelect(
                                                                                                                        task.id,
                                                                                                                        col.coloum,
                                                                                                                        col,
                                                                                                                        selectedBoardId,
                                                                                                                    );
                                                                                                                }}
                                                                                                            >
                                                                                                                <span>
                                                                                                                    {col.coloum}
                                                                                                                </span>
                                                                                                            </li>
                                                                                                        ),
                                                                                                    )
                                                                                                ) : (
                                                                                                    <li className="px-4 py-2 text-gray-400 text-sm">
                                                                                                        No columns found
                                                                                                    </li>
                                                                                                )}
                                                                                            </ul>
                                                                                        </React.Fragment>
                                                                                    ))
                                                                                ) : (
                                                                                    <li className="px-4 py-2 text-gray-400 text-sm">
                                                                                        No boards found
                                                                                    </li>
                                                                                )}
                                                                            </div>

                                                                            <div
                                                                                className="px-4 py-2 text-blue-500 text-sm cursor-pointer hover:underline border-t"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setOpenBoardTaskId(null);
                                                                                }}
                                                                            >
                                                                                Remove from board
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="flex justify-between">
                                                                    <div
                                                                        style={{
                                                                            display: 'flex',
                                                                            gap: '8px',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <div style={{ position: 'relative' }}>
                                                                            <span
                                                                                style={{



                                                                                    borderRadius: '4px',
                                                                                    fontSize: '12px',
                                                                                    padding: '2px 8px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '4px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleMyDayPlanClick(task.id);
                                                                                }}
                                                                            >
                                                                                {getTaskMyDayDate(task.id)
                                                                                    ? formatDateForDisplay(
                                                                                        getTaskMyDayDate(task.id),
                                                                                    )
                                                                                    : task?.myDayPlan
                                                                                        ? formatDateForDisplay(task.myDayPlan)
                                                                                        : 'myDayPlan'}
                                                                            </span>

                                                                            {openMyDayPlanDropdown === task.id && (
                                                                                <div
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        top: '100%',
                                                                                        left: '0',
                                                                                        zIndex: 1000,
                                                                                        marginTop: '5px',
                                                                                        background: '#fff',
                                                                                        border: '1px solid #e0e0e0',
                                                                                        borderRadius: '8px',
                                                                                        boxShadow:
                                                                                            '0 4px 12px rgba(0,0,0,0.15)',
                                                                                        minWidth: '260px',
                                                                                    }}
                                                                                >
                                                                                    <MyDayPlanDropdown
                                                                                        isOpen={true}
                                                                                        taskId={task.id}
                                                                                        taskItem={task}
                                                                                        type="DatePlan-Table"
                                                                                        onClose={() =>
                                                                                            setOpenMyDayPlanDropdown(null)
                                                                                        }
                                                                                        handleUpdateTask={handleUpdateTask}
                                                                                        getAllTask={getAllTask}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                    <div
                                                                        className="relative"
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            minWidth: '36px',
                                                                            minHeight: '36px',
                                                                        }}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                transition: 'opacity 0.2s',
                                                                                opacity:
                                                                                    assignedUser ||
                                                                                        hoveredTaskId === task.id ||
                                                                                        openAssignDropdownTaskId === task.id ||
                                                                                        openMyDayPlanDropdown === task.id ||
                                                                                        openTaskDeadlineDropdown === task.id
                                                                                        ? 1
                                                                                        : 0,
                                                                                pointerEvents:
                                                                                    assignedUser ||
                                                                                        hoveredTaskId === task.id ||
                                                                                        openAssignDropdownTaskId === task.id ||
                                                                                        openMyDayPlanDropdown === task.id ||
                                                                                        openTaskDeadlineDropdown === task.id
                                                                                        ? 'auto'
                                                                                        : 'none',
                                                                            }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleAssignChange(e, task.id);
                                                                            }}
                                                                        >
                                                                            {assignedUser ? (
                                                                                <span
                                                                                    className={`avatar-mail text-white w-[2.5vw] h-[2.5vw]`}
                                                                                >
                                                                                    {assignedUser.name?.charAt(0).toUpperCase()}
                                                                                </span>
                                                                            ) : (
                                                                                <span
                                                                                    style={{
                                                                                        border: '2px dotted #bbb',
                                                                                        borderRadius: '50%',
                                                                                        padding: '6px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        background: 'transparent',
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src="/assets/person.svg"
                                                                                        alt="person"
                                                                                        width={18}
                                                                                        height={18}
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </span>
                                                                        {openAssignDropdownTaskId === task.id && (
                                                                            <div
                                                                                className="assign-dropdown-wrapper"
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    top: assignDropdownPosition
                                                                                        ? `${assignDropdownPosition.top}px`
                                                                                        : 'auto',
                                                                                    right: assignDropdownPosition
                                                                                        ? `${assignDropdownPosition.right}px`
                                                                                        : 'auto',
                                                                                    zIndex: 1010,
                                                                                }}
                                                                            >
                                                                                <AssignDropdown
                                                                                    taskAssign={task.assignments || []}
                                                                                    handleAssign={handleAssign}
                                                                                    handleInputChange={handleInputChange}
                                                                                    handleClearAssignment={
                                                                                        handleClearAssignment
                                                                                    }
                                                                                    type="DateTable"
                                                                                    onClose={() => {
                                                                                        setOpenAssignDropdownTaskId(null);
                                                                                        setHoveredTaskId(null);
                                                                                    }}
                                                                                    openAssignDropdownTaskId={
                                                                                        openAssignDropdownTaskId
                                                                                    }
                                                                                    setSelectedAssighUser={(userId) =>
                                                                                        handleSetSelectedAssighUser(
                                                                                            task.id,
                                                                                            userId,
                                                                                        )
                                                                                    }
                                                                                    selectedAssighUser={
                                                                                        selectedAssighUser[task.id]
                                                                                    }
                                                                                    getAllTask={getAllTask}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {task?.notes && (
                                                                    <div
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            marginTop: '4px',
                                                                            maxWidth:
                                                                                hoveredTaskId === task.id ? '220px' : '100%',
                                                                        }}
                                                                    >
                                                                        <span style={{ fontWeight: 600, color: '#222' }}>
                                                                            Next step:{' '}
                                                                        </span>
                                                                        <span
                                                                            style={{
                                                                                color: '#444',
                                                                                fontWeight: 400,
                                                                                wordBreak: 'break-word',
                                                                                whiteSpace: 'pre-line',
                                                                            }}
                                                                        >
                                                                            {task?.notes}
                                                                        </span>
                                                                    </div>
                                                                )}


                                                            </div>
                                                        )}
                                                        {task.type === 'priorities' && (
                                                            <div style={{ marginBottom: '10px' }}>
                                                                <span>{task.content}</span>{' '}
                                                                <a
                                                                    href="#"
                                                                    style={{ color: '#007bff', textDecoration: 'none' }}
                                                                >
                                                                    {task.linkText}
                                                                </a>
                                                            </div>
                                                        )}
                                                        {task.type === 'task' && (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'space-between',
                                                                        marginBottom: '5px',
                                                                    }}
                                                                >
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <span style={{ marginRight: '5px', color: '#666' }}>
                                                                            &#9744;
                                                                        </span>
                                                                        <p
                                                                            style={{
                                                                                margin: 0,
                                                                                fontWeight: 'normal',
                                                                                color: '#333',
                                                                            }}
                                                                        >
                                                                            {task.name || task.title || task.subject}
                                                                        </p>
                                                                    </div>

                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        marginBottom: '5px',
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            backgroundColor: '#d4edda',
                                                                            color: '#155724',
                                                                            padding: '3px 8px',
                                                                            borderRadius: '3px',
                                                                            fontSize: '10px',
                                                                            marginRight: '5px',
                                                                        }}
                                                                    >
                                                                        {task.tagName || 'Task'}
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            backgroundColor: '#f0f0f0',
                                                                            color: '#888',
                                                                            padding: '3px 8px',
                                                                            borderRadius: '3px',
                                                                            fontSize: '10px',
                                                                        }}
                                                                    >
                                                                        P {task.tagDate || task.deadline}
                                                                    </span>
                                                                </div>
                                                                {task.nextStep && (
                                                                    <div
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            color: '#555',
                                                                            wordBreak: 'break-all',
                                                                        }}
                                                                    >
                                                                        Next step: {task.nextStep}
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                        {!task.taskType && !task.type && (
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    marginBottom: '5px',
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <span style={{ marginRight: '5px', color: '#666' }}>
                                                                        &#9744;
                                                                    </span>
                                                                    <p
                                                                        style={{
                                                                            margin: 0,
                                                                            fontWeight: 'normal',
                                                                            color: '#333',
                                                                        }}
                                                                    >
                                                                        {task.name ||
                                                                            task.title ||
                                                                            task.subject ||
                                                                            'Untitled Task'}
                                                                    </p>
                                                                </div>

                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                    <div className="task task-curve">
                                        <button
                                            style={{ opacity: '0.3' }}
                                            onClick={() => handleAddTask(column.id)}
                                            className="add-task-button"
                                        >
                                            <FontAwesomeIcon icon={faPlus} />
                                        </button>
                                    </div>
                                </div>
                                {provided.placeholder}
                            </div>
                        )
                        }
                    </Droppable>
                );
            })}

            {
                showBox === true && (
                    <ConfirmationPopup
                        taskToDeleteId={taskToDelete}
                        onCancel={handleCancelDelete}
                        deleteTaskMail={deleteTaskMail}
                    />
                )
            }
        </div >
    );
}

export default DatePlan;
